// Tiny dropdown hook — close on outside click + Escape. Used by Team /
// Project / User dropdowns in the shell. Pulled into its own file so the
// dashboard chrome stays under the 300-line per-file ceiling.

import { useEffect, useRef, useState } from 'react'

export function useDropdown() {
  const ref = useRef(/** @type {HTMLElement | null} */ (null))
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    /** @param {MouseEvent} e */
    function handleClick(e) {
      if (ref.current && !ref.current.contains(/** @type {Node} */ (e.target))) setOpen(false)
    }
    /** @param {KeyboardEvent} e */
    function handleKey(e) {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [open])

  return { ref, open, setOpen }
}
